// getListNotificationSaga
import { callApiServiceCommon } from "./service-common";

const commonApi = process.env.REACT_APP_API_CRONJOB_SERVICE_V1;

export function* updateNotificationService(id) {
  const payload = {
    method: "POST",
    url: `${commonApi}/ak/update-notification`,
    params: {
      app_code: process.env.REACT_APP_CODE,
      notification_id: id,
      read_status: true,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListNotificationService() {
  const payload = {
    method: "GET",
    params: {
      app_code: process.env.REACT_APP_CODE,
    },
    url: `${commonApi}/ak/get-notification`,
  };
  return yield callApiServiceCommon(payload);
}

export function* getNotificationDetailService(id) {
  const payload = {
    method: "GET",
    params: {
      app_code: process.env.REACT_APP_CODE,
      notification_id: id,
    },
    url: `${commonApi}/ak/get-notification`,
  };
  return yield callApiServiceCommon(payload);
}
